import React from 'react'
import { useApp } from '../../../context/AppProvider'
import { icon } from '../../../services/icon'
import { Parser } from '../../common'

const Help = () => {
    const { helpModal, setHelpModal } = useApp()

    return (
        <div
            onClick={() => setHelpModal(false)}
            className={`${!helpModal ? 'baseocom-modal-invisible' : 'baseocom-modal-visible '} baseocom-help-modal  `}
        >
            <div
                onClick={(e) => e.stopPropagation()}
                className={`  ${!helpModal ? 'baseocom-modal-container-invisible' : 'baseocom-modal-container-visible'} baseocom-help-modal-container`}
            >
                <div className="baseocom-btn-close-modal">
                    <button onClick={() => setHelpModal(false)}>
                        Fermer
                        {icon('close', '20')}
                    </button>
                </div>
                <div className="baseocom-modal-contains">
                    <Parser content_block={helpModal?.childrens} />
                </div>
            </div>
        </div>
    )
}

export default Help
